import React from 'react'

// http://www.hartzis.me/react-image-upload/

class FileUpload extends React.Component {


    createTieupArrayFromJSON(resultsAssociativeArray, resultsHandler) {

        let shaftsCount = resultsAssociativeArray.shaftsCount
        let treadlesCount = resultsAssociativeArray.treadlesCount
        let tieupArray = new Array(shaftsCount)

        for (let i = 0; i < shaftsCount; i++) {
            let shaftTreadlesArray = new Array(treadlesCount)
            tieupArray[i] = shaftTreadlesArray
        }

        var treadleNumbers = []
        for (let treadleNumber in Object.keys(resultsAssociativeArray.tieup)) {
            if (resultsAssociativeArray.tieup.hasOwnProperty(treadleNumber)) {
                treadleNumbers.push(parseInt(treadleNumber, 10));
            }
        }

        for (let treadleNumberValue = 0; treadleNumberValue < treadleNumbers.length; treadleNumberValue++) {
            let shaftAssignmentsArray = resultsAssociativeArray.tieup[treadleNumberValue]
            for (let i = 0; i < shaftAssignmentsArray.length; i++) {
                let shaftNumber = parseInt(shaftAssignmentsArray[i], 10)
                // reverse the vertical order
                let reversedShaftNumber = shaftsCount - shaftNumber - 1
                tieupArray[reversedShaftNumber][treadleNumberValue] = true
            }
        }

        resultsHandler(tieupArray, shaftsCount, treadlesCount)
    }


    handleFileUploaded(WIFText) {

        let formData = {
            'WIFData': WIFText
        }

        //let apiBaseUri = 'http://localhost:63291/'
        let apiBaseUri = 'https://api.handweaving.net/'

        fetch(apiBaseUri + 'api/v1/patterns/wiftieupjson', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(formData)
        }).then((response) => {
            // call the results handler after converting the response JSON to a tieup grid array
            response.json().then((body) => {
                let WIFUploadedSetNewTieupResultsFunction = this.props.WIFUploadedHandler
                this.createTieupArrayFromJSON(body, WIFUploadedSetNewTieupResultsFunction)
            })
        })
    }


    handleInputChange(e) {
        e.preventDefault();

        let reader = new FileReader()
        let file = e.target.files[0]

        reader.onload = (re) => {
            let fileContentsText = re.target.result
            this.handleFileUploaded(fileContentsText)
        }

        reader.readAsText(file)
    }

    render() {

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label htmlFor='textInputId' className="btn btn-primary reducer-button-file">
                        Choose WIF to Upload<input id='textInputId' accept='.wif' onChange={(e) => this.handleInputChange(e)} type="file" />
                    </label>
                </form>
            </div>
        )
    }


}

export default FileUpload


// WEBPACK FOOTER //
// ./src/scenes/reducer/components/FileUpload/index.js